import { RouteGenerator, RegistryInterface, isHTMLElementOfType } from "silver";

const LIST_ID = "lid";

type IDParser = (url: string) => number|null;
export const ViewStudentUserIDParser: IDParser = function(url: string): number|null {
	if (url.indexOf("students/view.html") === -1) {
		return null;
	}
	const matches = url.match(/[?&]id=(\d+)(&|$)/);
	if (!matches) {
		return null;
	}
	return Number(matches[1]);
};

function hashNumbers(input: number[]): number {
	return input.reduce((hash, number) => {
		hash = ((hash << 5) - hash) + number;
		return hash & hash;
	}, 0);
}

export class ListURLEncoderService {

	constructor(
		private router: RouteGenerator,
		private maxIds: number|undefined,
		private registry: RegistryInterface<number[]>
	) {}

	listenForLinkClick(root: Element, idParser: IDParser = ViewStudentUserIDParser): void {
		root.addEventListener("click", ({ target }) => {
			if (!isHTMLElementOfType(target, "a")) {
				return;
			}
			const id = idParser(target.href);
			const tbody = target.closest("tbody");
			if (!id || !tbody) {
				return;
			}
			const ids = this.limitIds(id, this.getIdOrderFromLinks(tbody, idParser));
			target.href = this.encodeListInURL(target.href, ids, id);
		})
	}

	private getIdOrderFromLinks(root: Element, idParser: IDParser): number[] {
		return Array.from(root.querySelectorAll("a"))
			.filter(a => a.offsetHeight > 0 || a.offsetWidth > 0)
			.map(({ href }) => idParser(href))
			.filter((id, index, set): id is number => (id !== null && (index === 0 || set[index - 1] != id))); // uniqueify
	}

	private limitIds(currentId: number, ids: number[]): number[] {
		if (this.maxIds === undefined || (this.maxIds >= ids.length)) {
			return ids;
		}
		const index = ids.indexOf(currentId);
		const firstIndex = Math.max(0, index - Math.floor(this.maxIds / 2));
		return ids.slice(firstIndex, firstIndex + this.maxIds);
	}

	encodeListInURL(url: string, ids: number[], currentId: number, listId?: string): string {
		const index = ids.indexOf(currentId);
		if (index === -1) {
			return url;
		}
		const route = this.router.parse(url);
		if (!route) {
			return url;
		}
		listId = hashNumbers(ids).toString(32);
		this.registry.set(listId, ids);
		return this.router.routeInfoToPath(route.withParameters({ [LIST_ID]: listId }));
	}

	getListFromURL(url: string): null|{ listId: string, ids: number[] } {
		const route = this.router.parse(url);
		if (!route || ! (LIST_ID in route.parameters)) {
			return null;
		}
		const listId = route.parameters[LIST_ID] as string;
		const ids = this.registry.get(listId);
		if (!ids) {
			return null;
		}
		return { listId, ids };
	}

}
